"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProgressIndicator_1 = require("./ProgressIndicator");
exports.default = ProgressIndicator_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ProgressIndicator/index.js
// module id = 1800
// module chunks = 8